import { cx } from "@jugl-web/utils";
import { useClipboard } from "@jugl-web/utils/hooks/useClipboard";

import { ReactComponent as CopyIcon } from "./assets/copy.svg";

interface CellCopyProps {
  copyContent?: string;
  successMessage?: string;
}

export const CellCopy = ({ copyContent, successMessage }: CellCopyProps) => {
  const { copyToClipboard } = useClipboard();

  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    copyToClipboard(copyContent ?? "", successMessage);
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={cx(
        "absolute top-1/2 right-4 hidden shrink-0 -translate-y-1/2 cursor-pointer items-center justify-center rounded border-none bg-gray-100 p-1 transition-all group-hover:flex hover:border-none"
      )}
      aria-label="Copy to clipboard"
    >
      <CopyIcon className="h-4 w-4 text-gray-500" />
    </button>
  );
};
